<template>
  <d-page-layout :hasSearch="false">
    <template slot="heading">
      <v-breadcrumbs class="pa-0" :items="items"></v-breadcrumbs>
    </template>
    <template slot="content">
      <h6
        class="text-h6 text-center font-weight-regular text--primary mb-2 mt-10"
      >
        {{ $t("home.text.welcome-title") }} {{ loggedInUserName }},
      </h6>
      <p class="text--primary text-center">
        {{ $t("home.text.welcome-text") }}
      </p>

      <div class="mt-10">
        <v-row>
          <template v-for="item in sidebarMenus">
            <v-col
              cols="12"
              md="4"
              lg="3"
              v-if="item.text != 'menu.dashboard'"
              class="mb-3"
              :key="item.text"
              v-granted="item.permission"
            >
              <v-card outlined elevation="0">
                <v-card-title>
                  <v-icon color="primary" size="36">{{ item.icon }}</v-icon>
                  <h6 class="ml-3 pt-1 text-h6 primary--text">
                    {{ $t(item.text) }}
                  </h6>
                </v-card-title>

                <v-card-actions>
                  <div class="d-flex justify-end w-100">
                    <v-btn
                      class="text-none text--secondary"
                      :to="item.link"
                      text
                    >
                      {{ $t("defaults.button.view") }}
                    </v-btn>
                  </div>
                </v-card-actions>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </div>
    </template>
  </d-page-layout>
</template>
<script>
import { mapGetters } from "vuex";
import sidebarMenus from "@/utils/sidebarMenus";

export default {
  data: (vm) => ({
    items: [
      {
        text: vm.$t("home.page-heading"),
        disabled: true,
      },
    ],
    sidebarMenus,
  }),
  computed: {
    ...mapGetters({
      loggedInUser: "Auth/getLoggedInUser",
    }),
    loggedInUserName() {
      return `${this.loggedInUser?.username}`;
    },
  },
};
</script>
